export default __webpack_public_path__ + "static/media/menuIcon.22791415.svg";